import type { SitrepZoneKind } from "@lancer-vtt/domain";

/** A human label for a zone kind — the board is read at a glance mid-fight, so "LANDING ZONE" beats
 *  the wire value `clear`. The board's zone label and the Inspect readout both print it. */
export const ZONE_KIND_LABEL: Record<SitrepZoneKind, string> = {
  clear: "LANDING ZONE",
  control: "CONTROL ZONE",
  deploy_pc: "PC DEPLOY",
  deploy_enemy: "ENEMY DEPLOY",
  extraction: "EXTRACTION",
  ingress: "INGRESS",
  objective: "OBJECTIVE",
};
